
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */


var Model = require("../types/Model.js");

module.exports = Model({
	name: "accountinvites",
	init: init,
	listeners: listeners,
	triggers: triggers,

	refresh: refresh,
	reset: reset,

	_ready: false,
});

function init() {
	this.push({
		list: [],
		message: ""
	});
}

function listeners() {
	return {
		"mqtt:$/contacts/invite/new": handle_new,
		"mqtt:$/contacts/invite/cancelled": clear_invite,
		"mqtt:$/contacts/invite/used": clear_invite,
		"connectivity:online": refresh,
		"loadchecker:ready": initial_load,
	};
}

function initial_load() {
	this._ready = true;
	this.refresh();
}

function triggers() {
	return {
		"cancel": handle_trigger_cancel,
		"send": handle_trigger_send,
		"accountinvites:reset": reset
	};
}

function handle_new(invite) {
	this.extend({
		list: this.data.list.concat(invite)
	});
}

function clear_invite(data) {
	var id = data._id;
	this.extend({
		list: this.data.list.filter(function (invite) {
			return invite._id !== id;
		})
	});
}

function refresh() {
	if(!this._ready) return;
	this.api.contacts.invite.list()
		.then(set_list.bind(this))
		.catch(console.error.bind(console));
}

function handle_trigger_cancel(data) {
  this.emit("save:trigger:start");
  var invite = data.invite;
  this.api.contacts.invite
    .cancel(invite)
    .catch(console.error.bind(console))
    .then(saveFinished.bind(this))
    .then(() =>
      this.dispatch("viewing", {
        who: this._who,
        section: "contacts",
        timestamp: new Date().toISOString(),
      })
    );
  this.emit("usermetrics:trigger:track", "cancel contact invite");
}

function handle_trigger_send(data) {
  this.emit("save:trigger:start");
  var email = data.email || data.query;
  var language = data.language;

  this.api.contacts.invite
    .send(email, language)
    .then(emit_sent.bind(this))
    .catch(handle_send_error.bind(this))
    .then(saveFinished.bind(this))
    .then(() =>
      this.dispatch("viewed", {
        who: this._who,
        section: "contacts",
        timestamp: new Date().toISOString(),
      })
    );
  this.emit("usermetrics:trigger:track", "send contact invite");
}

function saveFinished(){
	this.emit("save:trigger:finish");
	this.emit("search:trigger:clear");
	this.reset();
}

function reset() {
	this.extend({
		message: ""
	});
}

function handle_send_error(error) {
	console.error(error);
	var code = error.status;
	var error_message = "ae_invites_error_unknown";
	var error_map = {
		409: "ae_invites_error_already_requested",
		402: "ae_invites_error_already_registered",
		400: "ae_invites_error_specify_email",
		"": "ae_invites_error_unknown"
	};

	var found_error = error_map[code];
	if (found_error) error_message = found_error;

	this.extend({
		message: error_message
	});
}

function set_list(list) {
	this.extend({
		list: list
	});
}

function emit_sent() {
	this.dispatch("sent", {});
}
